<template>
    <v-dialog v-model="show" max-width="600px" persistent>
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon left color="white">
                    {{ modoEdicao ? 'mdi-pencil' : 'mdi-plus-circle' }}
                </v-icon>
                {{
                    modoEdicao
                        ? 'Editar Espécie de Título'
                        : 'Nova Espécie de Título'
                }}
                <v-spacer></v-spacer>
                <v-btn icon dark @click="fecharModal" :disabled="loading">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-6">
                <Loading :active="loading" :is-full-page="false" />

                <v-form ref="form" v-model="formValido" lazy-validation>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="form.cd_especie_titulo"
                                label="Código da Espécie *"
                                outlined
                                dense
                                :disabled="modoEdicao || loading"
                                :rules="modoEdicao ? [] : regrasCodigo"
                                maxlength="3"
                                counter="3"
                                hint="Máx. 3 caracteres"
                                persistent-hint
                                :class="modoEdicao ? 'readonly-field' : ''"
                            />
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-text-field
                                v-model="form.nm_especie_titulo"
                                label="Nome da Espécie *"
                                outlined
                                dense
                                :disabled="loading"
                                :rules="regrasNome"
                                maxlength="60"
                                counter="60"
                                hint="Máx. 60 caracteres"
                                persistent-hint
                            />
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                v-model="form.ds_complementar_especie_titulo"
                                label="Descrição Complementar"
                                outlined
                                dense
                                :disabled="loading"
                                :rules="regrasDescricao"
                                maxlength="200"
                                counter="200"
                                hint="Máx. 200 caracteres (opcional)"
                                persistent-hint
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select
                                v-model="form.requer_anexo"
                                :items="opcoesRequerAnexo"
                                item-text="label"
                                item-value="value"
                                label="Requer Anexo"
                                outlined
                                dense
                                :disabled="loading"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                    outlined
                    color="secondary"
                    @click="fecharModal"
                    :disabled="loading"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="primary"
                    @click="salvar"
                    :loading="loading"
                    :disabled="loading"
                    class="ml-2"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ modoEdicao ? 'Salvar Alterações' : 'Cadastrar' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EspecieTituloService from '@/services/EspecieTituloService';
import Loading from 'vue-loading-overlay';

export default {
    name: 'ModalEspecieTitulo',
    components: { Loading },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        especie: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            show: false,
            loading: false,
            formValido: true,
            form: {
                cd_especie_titulo: '',
                nm_especie_titulo: '',
                ds_complementar_especie_titulo: '',
                requer_anexo: 0
            },
            opcoesRequerAnexo: [
                { label: 'Não', value: 0 },
                { label: 'Sim', value: 1 }
            ],
            regrasCodigo: [
                v => !!v || 'Código é obrigatório',
                v =>
                    (v && v.length <= 3) ||
                    'Código deve ter no máximo 3 caracteres'
            ],
            regrasNome: [
                v => !!v || 'Nome é obrigatório',
                v =>
                    (v && v.length <= 60) ||
                    'Nome deve ter no máximo 60 caracteres'
            ],
            regrasDescricao: [
                v =>
                    !v ||
                    v.length <= 200 ||
                    'Descrição deve ter no máximo 200 caracteres'
            ]
        };
    },
    computed: {
        modoEdicao() {
            return !!this.especie;
        }
    },
    watch: {
        showModal: {
            handler(val) {
                this.show = val;
            },
            immediate: true
        },
        especie: {
            handler(val) {
                if (val) {
                    this.form = {
                        cd_especie_titulo: val.cd_especie_titulo || '',
                        nm_especie_titulo: val.nm_especie_titulo || '',
                        ds_complementar_especie_titulo:
                            val.ds_complementar_especie_titulo || '',
                        requer_anexo:
                            val.requer_anexo !== undefined
                                ? val.requer_anexo
                                : 0
                    };
                } else {
                    this.resetarForm();
                }
            },
            immediate: true
        }
    },
    methods: {
        fecharModal() {
            this.resetarForm();
            this.$emit('fecharModal');
        },

        resetarForm() {
            this.form = {
                cd_especie_titulo: '',
                nm_especie_titulo: '',
                ds_complementar_especie_titulo: '',
                requer_anexo: 0
            };
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },

        async salvar() {
            const valido = this.$refs.form.validate();
            if (!valido) return;

            this.loading = true;
            try {
                const service = new EspecieTituloService(
                    this.$http,
                    this.$store
                );

                if (this.modoEdicao) {
                    const payload = {
                        nm_especie_titulo: this.form.nm_especie_titulo,
                        ds_complementar_especie_titulo:
                            this.form.ds_complementar_especie_titulo,
                        requer_anexo: this.form.requer_anexo
                    };
                    await service.atualizarEspecie(
                        this.form.cd_especie_titulo,
                        payload
                    );
                    this.$emit(
                        'mostrarMensagem',
                        'Espécie de título atualizada com sucesso',
                        'success'
                    );
                } else {
                    await service.criarEspecie(this.form);
                    this.$emit(
                        'mostrarMensagem',
                        'Espécie de título cadastrada com sucesso',
                        'success'
                    );
                }

                this.$emit('atualizarLista');
                this.fecharModal();
            } catch (error) {
                const msg =
                    error?.data?.msg ||
                    (this.modoEdicao
                        ? 'Erro ao atualizar espécie de título'
                        : 'Erro ao cadastrar espécie de título');
                this.$emit('mostrarMensagem', msg, 'error');
                console.error('Erro ao salvar espécie de título:', error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.readonly-field :deep(input) {
    color: rgba(0, 0, 0, 0.38);
}
</style>
